import React from 'react';
import { Query } from 'react-apollo';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getCarRentalCompany } from '../../graphql/queries/carRentalCompany';
import Header from '../common/Header';
import RenderImage from '../common/RenderImage';

const CarRentalCompany = () => {
  let { id } = useParams();
  const { t } = useTranslation();

  return (
    <div className="list">
      <Header
        title="carRentalCompanies.show.title"
        linkTo={`/admin/car_rental_companies/${id}/edit`}
        buttonLabel="shared.edit"
      />
      <Query {...getCarRentalCompany(id)}>
        {({ loading, data }) => {
          if (loading) return <div className="lds-dual-ring" />;
          if (data) {
            const { carRentalCompany } = data;

            return (
              <div className="common-show">
                <div className="grid">
                  <div className="col-12">
                    <div className="common-show__infos">
                      <div className="col-12">
                        <div className="common-show__infos--field">
                          {t('carRentalCompanies.attributes.name')}
                        </div>
                        <div className="common-show__infos--value">{carRentalCompany.name}</div>
                        <div className="common-show__infos--field">
                          {t('carRentalCompanies.attributes.code')}
                        </div>
                        <div className="common-show__infos--value">{carRentalCompany.code}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="common-show__images">
                  <div className="common-show__infos--field">
                    {t('carRentalCompanies.attributes.image')}
                  </div>
                  <RenderImage url={carRentalCompany.imageUrls.large} />
                </div>
              </div>
            );
          }
          return null;
        }}
      </Query>
    </div>
  );
};

export default CarRentalCompany;
